import type { TFunction } from 'i18next'
import type { ScheduledReminder } from './schedule'

const sameDay = (a: Date, b: Date) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()

/** „14:00“ — oder „Do., 1.10., 14:00“, wenn der Bezug an einem anderen Tag liegt als das Klingeln. */
function whenLabel(anchorAt: Date, fireAt: Date, locale: string): string {
  const time = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(anchorAt)
  if (sameDay(anchorAt, fireAt)) return time
  return `${new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'numeric' }).format(anchorAt)}, ${time}`
}

/**
 * **Die Beschriftung einer Mitteilung**: Titel = die Aufgabe; darunter, was davor steht (die
 * oberste Aufgabe bei einer Unteraufgabe, Glossar), worauf sie sich bezieht und das Projekt —
 * „Wohnungsübergabe · Beginnt 09:30 · Umzug“. Desktop (`noticeOf`) und Mobile-App teilen sie.
 */
export function noticeText(entry: ScheduledReminder, projectName: string | null, t: TFunction, locale: string): { title: string; body: string } {
  const anchorLine = entry.anchor && entry.anchorAt
    ? t(entry.anchor === 'start' ? 'reminders.notification.startsAt' : 'reminders.notification.deadlineAt', { when: whenLabel(entry.anchorAt, entry.fireAt, locale) })
    : null
  const parts = [entry.parentTitle, anchorLine, projectName].filter((part): part is string => !!part)
  return {
    title: entry.taskTitle,
    body: parts.length > 0 ? parts.join(' · ') : t('reminders.notification.fallback'),
  }
}
